import { WindowConfig } from 'browser/types'

export const window: WindowConfig['window'] = () => ({
  width: 600,
  height: 400,
  title: 'Selenium IDE - Splash',
})
